<template>
    <line3d v-if="curvesReady" :map="map" :tb="tb" :lines="lines"
            :lineColor="lineColor" :lineWidth="lineWidth" :lineOpacity="lineOpacity" />
</template>

<script>
    import Line3d from "./Line3d";
    import {THREE} from 'threebox-plugin';
    import * as turf from '@turf/turf'

    // 根据端点数据列表，生成有高度的三维曲线
    export default {
        name: "Curve3d",
        components: {Line3d},
        props: {
            featureCollection:{
                required: true // 线数据列表，需要geoJson: FutureCollection<Future<LineString|MultiLineString>>
            },
            map:{
                required: true // mapbox对象
            },
            tb:{
                required: true // threebox对象
            },
            maxAltitude:{
                required: false, // 生成飞线最大高度，默认50万米
                default: 500000
            },
            sampling:{
                required: false, // 采样数，生成的一条曲线包含多少个点，默认50
                default: 50
            },
            lineColor:{
                required: false, // 画线颜色，默认白色
                default: '#FFFFFF'
            },
            lineWidth:{
                required: false, // 画线宽度，默认1
                default: 1
            },
            lineOpacity:{
                required: false, // 画线不透明度，默认1
                default: 1
            }
        },
        comments: {Line3d},
        data(){
            return{
                lines: [],
                curvesReady: false,
            }
        },
        methods:{
            line2Curve3d(lineList){
                // lineList是线的数组
                // 每一条线创建一组曲线
                for(let i=0; i < lineList.length; ++i){
                    const line = lineList[i];
                    const linePoints = [];
                    // 线中每两个点创建一条曲线
                    for(let j=0; j < line.length - 1; ++j){
                        const startPoint = line[j];
                        const endPoint = line[j + 1];

                        // 计算两端点的地面高度
                        const startElevation = this.map.queryTerrainElevation({lng: startPoint[0], lat: startPoint[1]}, { exaggerated: false });
                        const endElevation = this.map.queryTerrainElevation({lng: endPoint[0], lat: endPoint[1]}, { exaggerated: false });

                        // 曲线两端点和中点
                        const pointInLine = [
                            new THREE.Vector3(startPoint[0], startPoint[1], startElevation),
                            new THREE.Vector3((startPoint[0] + endPoint[0]) / 2,
                                (startPoint[1] + endPoint[1]) / 2, this.maxAltitude),
                            new THREE.Vector3(endPoint[0], endPoint[1], endElevation)
                        ];

                        // 利用three.js生成曲线
                        const curve = new THREE.CatmullRomCurve3(pointInLine);
                        const points = curve.getSpacedPoints(this.sampling);
                        points.forEach(p => {
                            linePoints.push([p.x, p.y, p.z]);
                        });
                    }

                    // 加入曲线集合
                    this.lines.push(linePoints);
                }
            },
            setCurves(){
                let lineList = [];

                // 遍历参数中的线型FeatureCollection
                turf.featureEach(this.featureCollection, function (feature, featureIndex) {
                    if(feature.geometry.type === "LineString"){
                        lineList.push(feature.geometry.coordinates);
                    }else if(feature.geometry.type === "MultiLineString") {
                        lineList = lineList.concat(feature.geometry.coordinates);
                    }
                });
                this.line2Curve3d(lineList);
            },
            mapFitBoundary(geo){
                const bbox = turf.bbox(geo)
                this.map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]],{
                    linear: false,
                    animate: true,
                    padding: {top: 120, bottom:130, left: 190, right: 500},
                })
            },
        },
        mounted() {
            this.mapFitBoundary(this.featureCollection)
            // 加载三维曲线
            this.setCurves();
            this.curvesReady = true;
        },
        destroyed() {
            this.curvesReady = false;
        }
    }
</script>

<style scoped>

</style>
